module.exports = __webpack_public_path__ + "static/media/thank-you.70f9da59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/buy-me-a-coffee/thank-you.svg
// module id = 643
// module chunks = 0